import React, { useState } from "react";
import { Outlet } from "react-router";
import AlertModal from "./AlertModal";

export default function AppContainer() {
  const [showAlert, setShowAlert] = useState(false);
  return (
    <div style={{ minHeight: "100vh" }}>
        <AlertModal show={showAlert} setShow={setShowAlert} />
        <Outlet context={[showAlert, setShowAlert]} /> {/* React-Router Boilerplate - This will render the nested routes */}
    </div>
  );
}